// extracted by mini-css-extract-plugin
module.exports = {"containerBox":"style_containerBox__6Qvq8","rowBox":"style_rowBox__3n06R"};